module.exports = __webpack_public_path__ + "static/media/page03_org.5bd7ef45.jpg";